import dayjs from "dayjs";

export const disabledTime = () => {
  const today = dayjs().startOf("day");
  const selectedDay = dayjs().startOf("day");

  if (selectedDay.isAfter(today)) {
    return {};
  }

  if (selectedDay.isSame(today)) {
    const currentHour = dayjs().hour();
    const currentMinute = dayjs().minute();

    return {
      disabledHours: () => Array.from({ length: currentHour }, (_, i) => i),
      disabledMinutes: (selectedHour: number) => {
        if (selectedHour === currentHour) {
          return Array.from({ length: currentMinute + 5 }, (_, i) => i);
        }
        return [];
      },
    };
  }
  return {
    disabledHours: () => Array.from({ length: 24 }, (_, i) => i),
    disabledMinutes: () => Array.from({ length: 59 }, (_, i) => i),
  };
};
